import React from 'react';
import { motion } from 'framer-motion';
import { CheckCheck } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    time: '10:42',
    text: 'Martín, acabo de cerrar mi primer presupuesto para un baño completo. El cliente quedó fascinado con las muestras. ¡Gracias por el sistema, está clarísimo!',
    focus: 'Primeros trabajos'
  }, {
    time: '14:15',
    text: 'Nunca había tocado una llana en mi vida. Ayer terminé la mesada de mi cocina y quedó espectacular. Ahora me pidieron presupuesto para un local.',
    focus: 'Aprendizaje'
  }, {
    time: '09:30',
    text: 'Lo que más me sirvió fue la parte de cómo calcular los materiales. Antes perdía plata por calcular mal, ahora voy a lo seguro.',
    focus: 'Comprensión del sistema'
  }, {
    time: '18:20',
    text: 'Ya recuperé la inversión del curso con el primer trabajo chico que agarré. La confianza que te da tener el paso a paso no tiene precio.',
    focus: 'Confianza'
  }];
  return <section className="py-12 md:py-16 px-4 bg-brand-gray border-t border-white/5" data-id="element-190">
      <div className="max-w-4xl mx-auto" data-id="element-191">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-192">
          <h2 className="text-4xl md:text-5xl lg:text-6xl text-white" data-id="element-193">
            MIENTRAS OTROS SIGUEN PENSANDO,{' '}
            <span className="text-brand-yellow" data-id="element-194">ESTOS YA ESTÁN AVANZANDO.</span>
          </h2>
        </motion.div>

        <div className="space-y-6 max-w-2xl mx-auto" data-id="element-195">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: i % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`flex ${i % 2 === 0 ? 'justify-start' : 'justify-end'}`} data-id="element-196">
              <div className="bg-[#005C4B] text-white p-4 rounded-2xl rounded-tr-sm max-w-[85%] shadow-lg relative" data-id="element-197">
                <p className="text-sm md:text-base mb-2 pr-4" data-id="element-198">{t.text}</p>
                <div className="flex items-center justify-end gap-1 text-xs text-white/70" data-id="element-199">
                  <span data-id="element-200">{t.time}</span>
                  <CheckCheck className="w-4 h-4 text-[#53bdeb]" data-id="element-201" />
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}